// extracted by mini-css-extract-plugin
export default {"content":"AuthContent_content__AcCOD"};